/**
 * Created by mgoria on 7/28/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourceNotFoundException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when resource not found
 */
let ResourceNotFoundException = exports.ResourceNotFoundException = function (_Exception) {
  _inherits(ResourceNotFoundException, _Exception);

  /**
   * @param {String|Number|null} resourceName
   */
  function ResourceNotFoundException() {
    let resourceName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, ResourceNotFoundException);

    let message = resourceName ? `Resource "${resourceName}" was not found.` : 'Resource not found.';

    return _possibleConstructorReturn(this, (ResourceNotFoundException.__proto__ || Object.getPrototypeOf(ResourceNotFoundException)).call(this, message, 404));
  }

  return ResourceNotFoundException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/Exception/ResourceNotFoundException.js
// module id = 369
// module chunks = 0